<script>
export default {
	props: {
		iconType: String,
		icon: String,
		iconHtml: String,
		iconImage: [Object, String],
	},
	computed: {
		show() {
			if (this.iconType == 'none') return false
			return this.icon || this.iconHtml || this.iconImage
		},
	},
}
</script>

<template>
	<div v-if="show">
		<v-icon v-if="!iconType || iconType == 'icon'">{{ icon }}</v-icon>
		<div v-else-if="iconType == 'html'" v-html="iconHtml"></div>
		<Media width="24px" height="24px" v-else-if="iconType == 'image'" :src="iconImage"></Media>
	</div>
</template>

